import { createContext, Dispatch, SetStateAction } from 'react';

export const ISPContext = createContext<string | null>(null);

export const ISPMutatorContext = createContext<Dispatch<SetStateAction<string | null>>>(() => {});
